import { date as q } from 'quasar';

/**
 * Форматирование даты в ISO
 * DD.MM.YYYY => YYYY-MM-DD
 * @param date
 */
export function formatDateIso(date: string) {
  const matches = date.match(/[0-9]+/g);
  return matches?.length ? matches.reverse().join('-') : date;
}

/**
 * Форматирование даты с ISO
 * YYYY-MM-DD => DD.MM.YYYY
 * @param date
 */
export function formatDateView(date: string) {
  const matches = date.match(/[0-9]+/g);
  return matches?.length ? matches.reverse().join('.') : date;
}

/**
 * Форматирование даты для пропса QDate
 * {date} => YYYY/MM/DD
 * @param date
 */
export function formatQDateOption(value: string | number) {
  const date = typeof value === 'string' ? value.replace(/-/g, '/') : value;
  return q.formatDate(date, 'YYYY/MM/DD');
}

export function toDayUTCBishkek() {
  const date = Date.now() + 6 * 60 * 60 * 1000;
  return new Date(date).toISOString().slice(0, 10).replace(/-/g, '/');
}

export function setDateIfWorkingDay(workingDays: string[], isEditPayment = false, valueDate = '') {
  const dateNow = formatQDateOption(Date.now());

  if (isEditPayment && workingDays.includes(formatQDateOption(valueDate))) return formatDateView(valueDate);

  return workingDays.includes(dateNow) ? formatDateView(dateNow) : '';
}
